<i [attr.data-feather]="icon"></i>
